import { leaveActionTypes } from './Leave.actionTypes';
const initialState = {
  managerRequests: [],
  loading: false,
  approveLoading: false,
  rejectLoading: false,
  error: null,
};

const leaveReducer = (state = initialState, action) => {
  switch (action.type) {
    case leaveActionTypes.SET_STATE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default leaveReducer;
